<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="user-tab" data-bs-toggle="tab" data-bs-target="#user-tab-pane" type="button" role="tab" aria-controls="user-tab-pane" aria-selected="true">بيانات العميل</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="nafath-tab" data-bs-toggle="tab" data-bs-target="#nafath-tab-pane" type="button" role="tab" aria-controls="nafath-tab-pane" aria-selected="false">بيانات نفاذ</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="bank-tab" data-bs-toggle="tab" data-bs-target="#bank-tab-pane" type="button" role="tab" aria-controls="bank-tab-pane" aria-selected="false">بيانات الحساب البنكي</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="account-managers-tab" data-bs-toggle="tab" data-bs-target="#account-managers-tab-pane" type="button" role="tab" aria-controls="account-managers-tab-pane" aria-selected="false">مديرين الحساب</button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade p-3 show active" id="user-tab-pane" role="tabpanel" aria-labelledby="user-tab" tabindex="0">
              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">الصورة الشخصية:</label>
                  <div>
                    <img v-if="dataRow.avatar" :src="MEDIA_URL+dataRow.avatar" class="img-thumbnail" style="max-width: 200px;" alt="">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">الاسم:</label>
                  <div>{{ name }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">رقم الهوية:</label>
                  <div>{{ dataRow.identity }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">الجوال:</label>
                  <div>{{ dataRow.mobile }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">تفعيل رقم الجوال:</label>
                  <div>{{ (dataRow.mobileVerified)? 'نعم ، مفعّل' : 'لا ، غير مفعّل' }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">البريد الإلكتروني:</label>
                  <div>{{ dataRow.email }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">تفعيل البريد الإلكتروني:</label>
                  <div>{{ (dataRow.emailVerified)? 'نعم ، مفعّل' : 'لا ، غير مفعّل' }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">حالة نفاذ:</label>
                  <div>{{ dataRow.nafathStatus }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">آخر تسجيل دخول:</label>
                  <div class="date-format">{{ (dataRow.lastLogin)? formatDate(dataRow.lastLogin) : '' }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">حالة الحظر:</label>
                  <div>{{ (isBlocked)? 'محظور' : 'غير محظور' }}</div>
                </div>
              </div>

            </div>
            <!-- Nafath -->
            <div class="tab-pane fade p-3" id="nafath-tab-pane" role="tabpanel" aria-labelledby="nafath-tab" tabindex="0">
              <div v-if="!dataRow.Nafath" class="row">
                <div class="col">
                  <div class="alert alert-info">لم يتم الحصول على بيانات من قبل نفاذ</div>
                </div>
              </div>
              <div v-else class="row">
                <div class="col">
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">معرف المستخدم:</label>
                      <div>{{ dataRow.Nafath.nin }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">كود الجنسية:</label>
                      <div>{{ dataRow.Nafath.nationality }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">رقم إصدار الهوية:</label>
                      <div>{{ dataRow.Nafath.idVersionNumber }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">مكان إصدار الهوية:</label>
                      <div>{{ dataRow.Nafath.idIssuePlace }}</div>
                      <div>{{ dataRow.Nafath.iqamaIssuePlaceDesc }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">تاريخ إصدار الهوية - ميلادي:</label>
                      <div>{{ dataRow.Nafath.idIssueDateG }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">تاريخ إصدار الهوية - هجري:</label>
                      <div>{{ dataRow.Nafath.idIssueDate }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">تاريخ إنتهاء الهوية - ميلادي:</label>
                      <div>{{ dataRow.Nafath.idExpiryDateG }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">تاريخ إنتهاء الهوية - هجري:</label>
                      <div>{{ dataRow.Nafath.idExpiryDate }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">الجنس:</label>
                      <div>{{ dataRow.Nafath.gender }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">الاسم الاول:</label>
                      <div>{{ dataRow.Nafath.firstName }}</div>
                      <div>{{ dataRow.Nafath.englishFirstName }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">اسم العائلة:</label>
                      <div>{{ dataRow.Nafath.familyName }}</div>
                      <div>{{ dataRow.Nafath.englishLastName }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">اسم الاب:</label>
                      <div>{{ dataRow.Nafath.fatherName }}</div>
                      <div>{{ dataRow.Nafath.englishSecondName }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">اسم الجد:</label>
                      <div>{{ dataRow.Nafath.grandFatherName }}</div>
                      <div>{{ dataRow.Nafath.englishThirdName }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">تاريخ الميلاد:</label>
                      <div>{{ dataRow.Nafath.dateOfBirthG }}</div>
                      <div>{{ dataRow.Nafath.dateOfBirthH }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">الحالة الاجتماعية:</label>
                      <div>{{ (socialStatusCodeObj[dataRow.Nafath.socialStatusCode] && socialStatusCodeObj[dataRow.Nafath.socialStatusCode][dataRow.Nafath.gender])? socialStatusCodeObj[dataRow.Nafath.socialStatusCode][dataRow.Nafath.gender] : 'غير معروف' }}</div>
                      <div>{{ dataRow.Nafath.socialStatusDesc }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">تاريخ آخر سفر - خروج:</label>
                      <div>{{ dataRow.Nafath.lastTravelExitDateG }}</div>
                      <div>{{ dataRow.Nafath.lastTravelExitDate }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">تاريخ آخر سفر - دخول:</label>
                      <div>{{ dataRow.Nafath.lastTravelEntryDateG }}</div>
                      <div>{{ dataRow.Nafath.lastTravelEntryDate }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">محل الميلاد:</label>
                      <div>{{ dataRow.Nafath.placeOfBirth }}</div>
                      <div>{{ dataRow.Nafath.placeOfBirthDesc }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">رقم جواز السفر:</label>
                      <div>{{ dataRow.Nafath.passportNumber }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">رمز المهنة:</label>
                      <div>{{ dataRow.Nafath.occupationCode }}</div>
                      <div>{{ dataRow.Nafath.occupationDesc }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">عدد المعالين:</label>
                      <div>{{ dataRow.Nafath.totalNumberOfCurrentDependents }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">كود الجنسية:</label>
                      <div>{{ dataRow.Nafath.nationalityCode }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">الجنسية:</label>
                      <div>{{ dataRow.Nafath.nationalityDesc }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">العنوان الوطني:</label>
                      <div>{{ dataRow.Nafath.nationalAddress }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">قاصر:</label>
                      <div>{{ dataRow.Nafath.isMinor }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">رب الاسرة:</label>
                      <div>{{ dataRow.Nafath.hohInfo }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">قاصر:</label>
                      <div>{{ dataRow.Nafath.isMinor }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">اسم الكفيل:</label>
                      <div>{{ dataRow.Nafath.sponsorName }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">الوضع القانوني:</label>
                      <div>{{ dataRow.Nafath.legalStatus }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">الحالة الاجتماعية:</label>
                      <div>{{ dataRow.Nafath.socialStatus }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">الوضع القانوني:</label>
                      <div>{{ dataRow.Nafath.legalStatus }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">مؤشر الدخول والخروج:</label>
                      <div>{{ dataRow.Nafath.inOutIndecator }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label for="" class="form-label">كود محل الميلاد:</label>
                      <div>{{ dataRow.Nafath.placeOfBirthCode }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Bank Account -->
            <div class="tab-pane fade p-3" id="bank-tab-pane" role="tabpanel" aria-labelledby="bank-tab" tabindex="0">
              <div v-if="!dataRow.Bank" class="row">
                <div class="col">
                  <div class="alert alert-info">لم يتم إدخال بيانات حساب بنكي من قبل العميل</div>
                </div>
              </div>
              <div v-else class="row">
                <div class="col">
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label class="form-label">اسم صاحب الحساب:</label>
                      <div>{{ dataRow.Bank.name }}</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label class="form-label">اسم البنك:</label>
                      <div>{{ dataRow.Bank.bankName }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                      <label class="form-label">رقم الحساب:</label>
                      <div>{{ dataRow.Bank.iban }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Account Managers -->
            <div class="tab-pane fade p-3" id="account-managers-tab-pane" role="tabpanel" aria-labelledby="account-managers-tab" tabindex="0">
              <AccountManagersPanel v-if="dataRow && dataRow.id" :userId="dataRow.id" :canEdit="false" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { formatDate } from '@/helpers/tools';
import { mapGetters } from 'vuex';
import AccountManagersPanel from '@/components/AccountManagersPanel.vue';

export default {
  name: 'ClientsView',
  components: {
    AccountManagersPanel,
  },
  props: {
    dataRow: {
      type: Object,
      default: null,
    },
    statusObject: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      restoreLoader: false,
      socialStatusCodeObj: {
        '0': {M: 'اعزب', F: 'غير معروف'},
        '1': {M: 'زوجة واحدة', F: 'غير متزوجة'},
        '2': {M: 'زوجتين', F: 'متزوجه'},
        '3': {M: 'ثلاث زوجات', F: 'مطلقه'},
        '4': {M: 'أربع زوجات', F: 'أرمله'},
        '5': {M: 'غير معروف', F: 'مطلقة معلقة'},
      },
      name: '',
      isBlocked: false,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  methods: {
    formatDate,
  },
  created(){
    if(this.dataRow){
      this.name = this.dataRow.name;
      this.isBlocked = this.dataRow.isBlocked;
    }
  }
}
</script>